type MaterialIconProps = React.SVGProps<SVGSVGElement>;

const MaterialIcon: React.FC<MaterialIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="-22 -12 100 100"
      fill="none"
      {...props}
    >
      <path
        d="M10.4749 58.3835L28.5889 69.2371V75.4071L10.4749 64.5535V58.3835Z"
        fill="#DDB96E"
      />
      <path
        d="M10.4727 58.3849L28.5889 69.2369L46.5314 58.4695L28.4089 47.6175L10.4727 58.3849Z"
        fill="#F9E4B9"
      />
      <path
        d="M28.5891 69.2373L46.5377 58.4634V64.6334L28.5891 75.4073V69.2373Z"
        fill="#7C612E"
      />
      <path
        d="M33.7221 8.66445L15.266 18.9276L15.6195 39.8499L34.0787 29.5814L33.7221 8.66445Z"
        fill="#7C612E"
      />
      <path
        d="M33.7222 8.66699L15.2657 18.9274L9.92233 15.8424L28.3788 5.582L33.7222 8.66699Z"
        fill="#F9E4B9"
      />
      <path
        d="M15.2657 18.9272L15.6219 39.8581L10.2785 36.7731L9.92232 15.8422L15.2657 18.9272Z"
        fill="#DDB96E"
      />
      <path
        d="M48.6044 28.366C47.6984 28.4239 46.7554 28.7227 45.8399 29.213C44.0425 30.1757 42.2924 31.9015 40.9936 34.151C39.6949 36.4005 39.0753 38.779 39.1404 40.817C39.1735 41.855 39.3862 42.821 39.789 43.6347L21.7274 33.2068L30.5428 17.9381L48.6044 28.366Z"
        fill="#DDB96E"
        stroke="black"
        strokeWidth="0.755155"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4514 32.9059C17.7223 31.3302 17.5678 26.4884 20.1064 22.0915C22.6449 17.6946 26.9153 15.4075 29.6444 16.9832L30.4045 17.422L30.405 17.4212L50.859 29.2304L41.666 45.1531L28.2407 37.4019L28.2402 37.4027L20.4514 32.9059Z"
        fill="#F2D497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4514 32.9057C17.7223 31.33 17.5678 26.4882 20.1064 22.0913L25.8687 25.3492L25.8844 25.3223L31.1918 28.3587L31.3142 28.428L31.314 28.4286L46.3539 37.0332L41.6661 45.1528L28.2406 37.4015L28.2402 37.4025L20.4514 32.9057Z"
        fill="#BB9446"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5487 44.8529C53.2451 43.2506 55.0521 40.3085 55.0521 36.9444C55.0521 31.8673 50.9363 27.7515 45.8592 27.7515C43.7255 27.7515 41.7615 28.4784 40.2015 29.6981L24.315 40.1579C21.4369 41.707 19.4791 44.7452 19.4728 48.2412H19.4727V56.1923V56.7564V57.6344C19.4727 60.7858 23.5885 63.3404 28.6656 63.3404C33.7428 63.3404 37.8586 60.7858 37.8586 57.6344V56.7564V56.1923V53.2139L50.5487 44.8529Z"
        fill="#BB9446"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.1718 29.7022C40.5063 29.4412 40.8629 29.2002 41.2409 28.9819C45.6378 26.4434 51.2601 27.9499 53.7987 32.3468L54.1808 33.0324L54.0157 33.1186L28.6439 49.1352V55.3574V63.3393C23.5668 63.3393 19.451 60.7846 19.451 57.6333V56.7554V56.1911V48.2888L19.4509 48.2571C19.4509 44.7538 21.4105 41.7083 24.2932 40.1567L40.1718 29.7022Z"
        fill="#F2D497"
      />
    </svg>
  );
};

export default MaterialIcon;
